import { reduce } from 'underscore';

export const getSelectedNodes = nodes => reduce(nodes, (selectedNodes, node) => {
  if (node.state && node.state.checked) {
    selectedNodes.push(node);
  }
  if (node.children) {
    selectedNodes.push(...getSelectedNodes(node.children));
  }
  return selectedNodes;
}, []);
